export default {
  methods: {
    /**
     * @method readFromStorage
     * @description Lee la data desde el storage y se la setea al engine
     * @param {*} type
     */
    readFromStorage(type) {
      try {
        let exerciseID = null;
        if (this.$props.exercise) {
          exerciseID = this.$props.exercise.ID;
        }
        if (exerciseID === null) { // Means there is no exercise created here, get tempID from storage
          const tempID = window.sessionStorage.getItem('tempEngineID');
          exerciseID = `tempID_${this.type}_${tempID}`;
        }
        console.log(`readFromStorage: ${exerciseID}`);

        const data = JSON.parse(window.sessionStorage.getItem(`engine_${type}_${exerciseID}`));

        this.$data.configuration = data.configuration;
        this.$data.arrayEleOperation = data.elements;

        this.$data.selectedNumOpertion = (typeof (data.totalElements) === 'string' ? parseInt(data.totalElements, 10) : data.totalElements);
      } catch (e) {
        // nothing
        console.log('error at readFromStorage');
      }
    },
    /**
    * @method saveStorage
    * @description Guarda los datos del formulario
    */
    saveStorage() {
      this.$refs.exercise_child.$refs.formValidation.validate().then((exerciseOK) => {
        if (!exerciseOK) {
          return;
        }

        this.$refs.formValidation.validate().then((success) => {
          if (!success) {
            return;
          }

          this.$nextTick(() => {
            this.$refs.exercise_child.active();
          });

          const { objexercise } = this.$refs.exercise_child;
          const motorData = {
            exercise: objexercise,
            configuration: this.$data.configuration,
            elements: this.$data.arrayEleOperation,
            totalElements: this.$data.arrayEleOperation.length,
          };

          let exerciseID = null;
          if (this.$props.exercise) {
            exerciseID = this.$props.exercise.ID;
          }
          if (exerciseID === null) { // Means there is no exercise created here, get tempID from storage
            const tempID = window.sessionStorage.getItem('tempEngineID');
            exerciseID = `tempID_${this.type}_${tempID}`;
          }
          console.log(`saveStorage: ${exerciseID}`);

          // Grabo los datos del motor
          window.sessionStorage.setItem(`engine_${this.$props.type}_${exerciseID}`, JSON.stringify(motorData));

          // Cierro el modal
          this.$root.$emit('bv::hide::modal', `baseEngineModal_${this.$props.type}`);
        });
      });
    },
    /**
    * @method updatedNumOperation
    * @description Updated value in exercise parent with max posible
    */
    updatedNumOperation() {
      // el NUM DE operation debo grabarlo en el objeto EJERCICIO
      const { objexercise } = this.$refs.exercise_child;
      objexercise.MAX_NUM_ELEMENTOS = parseInt(this.$data.arrayEleOperation.length, 10);
      // Used in first load, adds the first required one
      if (this.$data.arrayEleOperation.length <= 0) {
        this.addArrayEleOperation();
      }
    },
    /**
     * @method parseSerieElement
     * @description Swaps elements in series from the databse value
     * @param {*} VALOR
     * @param {boolean} saving True if value visible transforms to database
     */
    parseSerieElement(VALOR, saving) {
      let VALOR_TRANSFORMER = '';

      if (saving) {
        if (VALOR === '<') {
          VALOR_TRANSFORMER = 'LT';
        } else if (VALOR === '>') {
          VALOR_TRANSFORMER = 'MT';
        } else if (VALOR === 'Multiplo') {
          VALOR_TRANSFORMER = 'M';
        } else if (VALOR === 'Divisor') {
          VALOR_TRANSFORMER = 'D';
        } else if (VALOR === 'Doble') {
          VALOR_TRANSFORMER = 'B';
        } else if (VALOR === 'Divisible') {
          VALOR_TRANSFORMER = 'V';
        } else if (VALOR === 'Equivalente') {
          VALOR_TRANSFORMER = 'E';
        } else {
          VALOR_TRANSFORMER = VALOR;
        }
      } else if (!saving) {
        if (VALOR === 'LT') {
          VALOR_TRANSFORMER = '<';
        } else if (VALOR === 'MT') {
          VALOR_TRANSFORMER = '>';
        } else if (VALOR === 'M') {
          VALOR_TRANSFORMER = 'Multiplo';
        } else if (VALOR === 'D') {
          VALOR_TRANSFORMER = 'Divisor';
        } else if (VALOR === 'B') {
          VALOR_TRANSFORMER = 'Doble';
        } else if (VALOR === 'V') {
          VALOR_TRANSFORMER = 'Divisible';
        } else if (VALOR === 'E') {
          VALOR_TRANSFORMER = 'Equivalente';
        } else {
          VALOR_TRANSFORMER = VALOR;
        }
      }

      return VALOR_TRANSFORMER;
    },
  },
};
